import firebase from 'firebase'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueCurrencyInput from 'vue-currency-input'
import VuePapaParse from 'vue-papa-parse'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyByaXsdrjtjEbUo53M5DdA6v3tHdcTYSAs',
  authDomain: 'mimicando-193602.firebaseapp.com',
  databaseURL: 'https://mimicando-193602.firebaseio.com',
  projectId: 'mimicando-193602',
  storageBucket: 'mimicando-193602.appspot.com',
  messagingSenderId: '840769532800',
  appId: '1:840769532800:web:763c8d60b0364fe4c18765',
  measurementId: 'G-DGV57BZ8EH',
}
firebase.initializeApp(firebaseConfig)
export const db = firebase.firestore()
export const storageRef = firebase.storage().ref()
export const packsRef = storageRef.child('packs');

// Vue.filter('toCurrency', function (value) {
//   if (isNaN(parseFloat(value))) {
//     console.log('eh nan')
//     return value
//   }
//   var formatter = new Intl.NumberFormat('pt-BR', {
//     style: 'currency',
//     currency: 'BRL',
//     minimumFractionDigits: 0
//   })
//   return formatter.format(value)
// })

// Vue.use(VueCurrencyInput)

Vue.use(VuePapaParse)

let app = ''
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
